 export class Customer{
     constructor(
        public unique: String = '' 
     ){}
 } 